module.exports = __webpack_public_path__ + "img/logo.8852c203.png";